module.exports = new __parcel__URL__("step-automate-alert-and-incident-response.04583c29.svg").toString();